import styled, { css } from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const Dropdown = styled.div`
  position: fixed;
  z-index: 1100;
  overflow-y: auto;
  background: ${props => props.theme.colors.dropdownMenu};
  border: 1px solid ${props => props.theme.colors.borderLight};
  border-radius: .25rem;
  box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .35);
`;

export const DropdownHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${props => props.theme.colors.dropdownMenu};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .5rem;
  padding: .6rem 1rem;
  border-bottom: 1px solid ${props => props.theme.colors.borderLight};
  font-size: .875rem;
  color: ${props => props.theme.colors.muted};

  button {
    background: none;
    border: 0;
    color: ${props => props.theme.colors.primary};
    font-size: .875rem;
    cursor: pointer;
  }
`;

export const Option = styled.button<{ highlighted?: boolean }>`
  display: block;
  width: 100%;
  padding: .6rem 1rem;
  border: 0;
  text-align: left;
  background: none;
  color: ${props => props.theme.colors.text};
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.hover};
    color: ${props => props.theme.colors.hoveredText};
  }

  span {
    display: block;
    font-size: .75rem;
    color: ${props => props.theme.colors.muted};
  }

  ${props => props.highlighted && css`
    color: ${props.theme.colors.primary};
    font-weight: bold;
    border-bottom: 1px solid ${props.theme.colors.borderLight};
  `}
`;

export const EmptyMessage = styled.div`
  padding: .6rem 1rem;
  font-size: .875rem;
  color: ${props => props.theme.colors.muted};
`;

export const SelectedLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .5rem;
  padding: .6rem 1rem;
  border: 1px solid ${props => props.theme.colors.borderLight};
  border-radius: .25rem;
  background: ${props => props.theme.colors.inputBackground};

  strong {
    display: block;
    color: ${props => props.theme.colors.text};
  }

  span {
    display: block;
    font-size: .75rem;
    color: ${props => props.theme.colors.muted};
  }
`;

export const CurrentLinkHint = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .5rem;
  margin-bottom: .4rem;
  font-size: .75rem;
  color: ${props => props.theme.colors.muted};

  strong {
    font-weight: normal;
    color: ${props => props.theme.colors.text};
  }

  button {
    flex-shrink: 0;
    background: none;
    border: 0;
    font-size: .75rem;
    cursor: pointer;
    color: ${props => props.theme.colors.primary};
  }
`;

export const LinkActions = styled.div`
  display: flex;
  gap: .75rem;
  flex-shrink: 0;

  button {
    background: none;
    border: 0;
    font-size: .875rem;
    cursor: pointer;
    color: ${props => props.theme.colors.primary};

    & + button {
      color: ${props => props.theme.colors.danger};
    }
  }
`;

export const LoadingIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
`;

export const AdminBadge = styled.span`
  && {
    display: inline-block;
    margin-left: .4rem;
    font-size: .625rem;
    text-transform: uppercase;
    color: ${props => props.theme.colors.accent};
  }
`;
